import React, { FC } from 'react';
import PlatformPDFViewer from "./Platform";

type Props = {
    uri?: string;
};

const PDFViewer: FC<Props> = ({ uri }) => {

    if (!uri) {
        return null;
    }

    return <PlatformPDFViewer uri={uri} />;
};


export default PDFViewer;